'use strict';

var getPolyfill = require('./polyfill');

var polyfill = getPolyfill();

module.exports = polyfill;
